import { BasketItem } from './item';
import currency from 'currency.js';
import { useBasket } from 'lib/hooks/basket/use-basket';
import { StandardInput } from 'components/forms/input';
import { getBasketTotal } from 'lib/basket/helpers';
import { VouchersSection } from './vouchers';
import {
  useGetUnstructuredDataQuery,
  useGetWrapppingPriceQuery,
} from 'lib/graphql-generated';
import { Spinner } from 'components/spinner';
import { RenderContent } from 'components/content-renderer';
import { DiscountSection } from './discounts';
import { ClientOnly } from 'components/client-only';

export const BasketItems = () => {
  const [basket, modifyBasket] = useBasket();
  const { data, loading } = useGetWrapppingPriceQuery();
  const { data: pifData, loading: pifLoading } = useGetUnstructuredDataQuery({
    variables: { title: 'pif' },
  });

  return (
    <ul className='divide-y-2 border-gray-200 border rounded-md p-4'>
      <ClientOnly>
        {basket.items.length > 0 ? (
          basket.items.map((item, index) => (
            <li key={`${item.id}_${index}`} className='py-4'>
              <BasketItem item={item} />
            </li>
          ))
        ) : (
          <li className='relative py-4 text-sm text-center w-full flex'>
            <p className='mx-auto'>
              There are no items in your basket - you can still purchase a Pay
              It Forward contribution!
            </p>
          </li>
        )}

        <li className='relative py-4 flex flex-row flex-wrap'>
          <input
            className='focus:ring-indigo-500 h-4 w-4 mt-1 text-green-default cursor-pointer border-gray-300'
            type='checkbox'
            name='pif'
            id='pif'
            checked={basket.pif !== null}
            onChange={(e) => {
              if (e.target.checked) {
                modifyBasket({
                  type: 'modify-pif',
                  payload: 500,
                });
              } else {
                modifyBasket({
                  type: 'modify-pif',
                  payload: null,
                });
              }
            }}
          />
          <label htmlFor='pif' className='ml-3 flex flex-col cursor-pointer'>
            <h3 className='font-bold text-sm space-x-1'>
              <span>Add a</span>
              <u className='underline'>Pay It Forward</u>
              <span>contribution?</span>
            </h3>
          </label>
          <div className='prose text-sm pl-7 py-2 w-full'>
            {!pifLoading && pifData?.unstructured_data_by_pk && (
              <RenderContent
                content={pifData.unstructured_data_by_pk.data.content}
              />
            )}
          </div>
          {basket.pif !== null && (
            <div className='ml-auto'>
              <StandardInput
                label='Amount (£)'
                id='pifAmount'
                name='pifAmount'
                type='number'
                labelProps={{ className: 'ml' }}
                inputProps={{ min: 0, className: 'text-right pr-2' }}
                bind={{
                  value: currency(basket.pif, { fromCents: true }).value,
                  onChange: (e) => {
                    modifyBasket({
                      type: 'modify-pif',
                      payload: currency(Math.round(parseInt(e.target.value)))
                        .intValue,
                    });
                  },
                }}
                className=''
              />
            </div>
          )}
        </li>
        {basket.items.length > 0 && (
          <>
            {loading ? (
              <Spinner />
            ) : (
              <li className='relative py-4 flex'>
                <input
                  className='focus:ring-indigo-500 h-4 w-4 my-auto text-green-default cursor-pointer border-gray-300'
                  type='checkbox'
                  name='wrapping'
                  id='wrapping'
                  checked={!!basket.wrapping}
                  onChange={(e) => {
                    if (e.target.checked) {
                      modifyBasket({
                        type: 'toggle-wrapping',
                        payload: data.unstructured_data_by_pk.data.price,
                      });
                    } else {
                      modifyBasket({
                        type: 'toggle-wrapping',
                        payload: null,
                      });
                    }
                  }}
                />

                <label
                  htmlFor='wrapping'
                  className='ml-3 flex flex-col cursor-pointer'>
                  <h3 className='font-bold text-sm my-auto'>
                    Add gift wrapping?
                  </h3>
                </label>
                <div
                  className={`ml-auto flex flex-row justify-end space-x-4 ${
                    !!basket.wrapping ? '' : 'text-gray-400'
                  }`}>
                  <h4>Total:</h4>
                  <span className='ml-auto font-bold'>
                    {currency(data.unstructured_data_by_pk.data.price, {
                      fromCents: true,
                      symbol: '£',
                    }).format()}
                  </span>
                </div>
              </li>
            )}
          </>
        )}
        <VouchersSection />
        <DiscountSection />
        <li className='pt-8 flex flex-row space-x-4 justify-end'>
          <h2>Items Total: </h2>
          <span className='font-bold'>
            {currency(getBasketTotal(basket), {
              fromCents: true,
              symbol: '£',
            }).format()}
          </span>
        </li>
      </ClientOnly>
    </ul>
  );
};
